/*
 * Created Date: 22-02-2024, 2:33:59 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Thu Feb 22 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { getAuthDataSession } from '@Core/Helpers/Session'
import BaseService from '@Core/axios/BaseService'
import Axios from 'axios'

// import { CREATE_EXAM_AI_BE_URL } from 'env'

class CreateExamAi extends BaseService {
	constructor(props) {
		super(props)
		// this.BASE_URL = 'http://127.0.0.1:8080'
		this.setRequest()
	}

	uploadFiles = data => {
		const endpoint = '/workspace/studio/api/v1/admin/ai-detect-exam/create?ver=2'
		return this.request.post(endpoint, data)
		// return axios.post(endpoint, data, { headers: { 'Content-Type': 'multipart/form-data' } })
	}

	checkStatus = order_id => {
		const params = {
			order_id,
			version: 2
		}
		const endpoint = '/workspace/studio/api/v1/admin/ai-detect-exam/check-status'
		return this.request.get(endpoint, { params })
	}

	getResult = order_id => {
		const endpoint = '/workspace/studio/api/v1/admin/ai-detect-exam/get-result'
		const params = {
			order_id,
			version: 2
		}
		return this.request.get(endpoint, { params })
	}
}

const adminExamAiService = new CreateExamAi()

export default adminExamAiService
